module.exports = __webpack_public_path__ + "static/media/swords.a4c9ac11.svg";